/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SafetyDto } from '../../models/safety-dto';

export interface GetActiveSafetiesForCustomer$Params {
  customerGUID: string;
}

export function getActiveSafetiesForCustomer(http: HttpClient, rootUrl: string, params: GetActiveSafetiesForCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SafetyDto>>> {
  const rb = new RequestBuilder(rootUrl, getActiveSafetiesForCustomer.PATH, 'get');
  if (params) {
    rb.query('customerGUID', params.customerGUID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SafetyDto>>;
    })
  );
}

getActiveSafetiesForCustomer.PATH = '/safeties/active-safeties';
